import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';
import { categoryMap } from '@/mocks/categories';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩漫之家`}
          title={`${comic.title} - 韩国漫画在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-white'
              : 'bg-secondary-500 text-white'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2 text-white text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-yellow-400"></i>
              {comic.rating}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {(comic.views / 10000).toFixed(1)}万
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-foreground-900 text-sm group-hover:text-primary-600 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author} · {categoryMap[comic.category] || comic.category}</p>
      </div>
    </Link>
  );
}